/* eslint-disable no-unused-vars */
import { Grid, Typography, CircularProgress } from "@mui/material";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";

import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import Select from "react-select";
import { SaleUtils } from "../../../utils/SaleUtils";

const customStyles = {
  control: (base) => ({
    ...base,
    height: 35,
    minHeight: 35,
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export default function EmployeeCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("New Employee");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");
  const [code, setCode] = useState("");

  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [employeeTypes, setEmployeeTypes] = useState([]);

  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  const empTypeOptions = [
    { value: "delivery", label: "Delivery" },
    { value: "security", label: "Security" },
    { value: "salesman", label: "Salesman" },
    { value: "manager", label: "Manager" },
    { value: "cleaning", label: "Cleaning Person" },
  ];

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showEmployeeCrudWindow: showEmployeeCrudWindow,
  };

  useEffect(() => { }, []);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);

  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showEmployeeCrudWindow(employeeId) {
    if (employeeId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
    } else {
      setMode("edit");
      populateEmployee(employeeId);
    }
  }
  async function populateEmployee(id) {
    {
      try {
        let { data } = await API.get("/api/v1/employee/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Employee data from server")
        );
      }
    }
  }

  function populateData(bean) {
    setWindowTitile(bean.name);
    setName(bean.name);
    setContact(bean.contact);
    setAddress(bean.address);
    let empTypes = [];
    if (bean.empTypes) {
      for (let d of bean.empTypes) {
        empTypes.push(SaleUtils.getOption2(empTypeOptions, d));
      }
    }
    setEmployeeTypes(empTypes);

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");
    setContact("");
    setAddress("")
    setEmployeeTypes([]);
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete employee") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/employee/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Employee") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Employee"));
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/employee", payload);
        props.showMessage("success", translate("Saved Successfully"));
        if (props.onRefresh != null && props.onRefresh != undefined)
          props.onRefresh();
        if (props.selectEmployee != null && props.selectEmployee != undefined)
          props.selectEmployee(result.data);
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Employee"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }

      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;
    saveObject["address"] = address;
    saveObject["contact"] = contact;
    saveObject["empTypes"] = employeeTypes;
    let empTypes = [];
    for (let e of employeeTypes) {
      empTypes.push(e.value);
    }
    saveObject["empTypes"] = empTypes;
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }

    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }

    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const content = (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">{translate("Name")}</Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Contact")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Address")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Employee Type")}
                  </Typography>
                </td>
                <td>
                  <Select
                    isMulti
                    styles={customStyles}
                    menuPortalTarget={document.body}
                    name="colors"
                    options={empTypeOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={employeeTypes}
                    onChange={(newValue) => setEmployeeTypes(newValue)}
                  />
                </td>
              </tr>
              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (contact !== origObject.contact) return true;
    }
    if (mode === "edit") {
      if (address !== origObject.address) return true;
    }

    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/

    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"sm"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
